<template xmlns:width="http://www.w3.org/1999/xhtml">
  <q-page class="column" v-if="item">
    <div v-show="overrideView" id="overrideViewDiv"></div>
    <q-toolbar class="bg-secondary text-white" v-if="!overrideView">
      <q-btn flat dense
             :icon="customButtonIcon(btn)"
             @click="customButtonClick(btn)"
             v-for="btn in editorConfig.buttons || []"
             :key="btn.name">
        <q-tooltip :offset="[0, 10]">{{customButtonName(btn)}}</q-tooltip>
      </q-btn>

      <q-toolbar-title></q-toolbar-title>

      <q-btn-group class="q-mr-sm">
        <q-btn v-for="split in Object.values(splits)" :key="split.index"
               :color="split.visible ? (split.locked ? 'tertiary' : 'white') : 'secondary'"
               :text-color="split.visible ? 'secondary' : 'white'"
               :icon="split.icon"
               dense
               @click="clickSetSplit(split)" />
      </q-btn-group>

      <q-btn flat dense icon="fas fa-external-link-alt" @click="openInPopup" v-if="$q.platform.is.desktop"/>
      <q-btn flat dense icon="fas fa-expand-arrows-alt" @click="toggleDistractionFreeMode(false)"/>
      <q-btn-dropdown dense flat v-if="$q.platform.is.desktop && !distractionFreeMode">
        <q-list link>
          <q-item @click.native="toggleDistractionFreeMode(false)" v-close-popup clickable>
            <q-item-section>
              <q-item-label>
                Distraction Free Mode
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item @click.native="toggleDistractionFreeMode(true)" v-close-popup clickable>
            <q-item-section>
              <q-item-label>
                Fullscreen
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </q-toolbar>

<!--    <q-splitter-->
<!--      v-model="splitterModel"-->
<!--      style="height: 400px"-->
<!--    >-->

<!--      <template v-slot:before>-->
<!--        <ace-editor-->
<!--          content="123">-->
<!--        </ace-editor>-->
<!--      </template>-->

<!--      <template v-slot:after>-->
<!--        <div class="q-pa-md">-->
<!--          <div class="text-h4 q-mb-md">After</div>-->
<!--          <div v-for="n in 20" :key="n" class="q-my-md">{{ n }}. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quis praesentium cumque magnam odio iure quidem, quod illum numquam possimus obcaecati commodi minima assumenda consectetur culpa fuga nulla ullam. In, libero.</div>-->
<!--        </div>-->
<!--      </template>-->

<!--    </q-splitter>-->

    <div class="split col"
         :class="{'split-horizontal': layoutOrientation === 'horizontal',
                  'split-vertical': layoutOrientation === 'vertical'}">
      <div v-for="(editorInfo, editor) in splits" :key="editor"
           :id="'ace' + editor + 'div'" v-show="editorInfo.visible"
           class="col" style="display: block;">
        <ace-editor
                v-if="editorInfo.content === 'editor' && !$q.platform.is.mobile"
                :ref="'ace' + editor"
                :content="aceContent(editor)"
                :sync="true"
                :options="aceOpts(editor)"
                @change="codeChange(editor, ...arguments)"
                @scrollV="scrollHandler(editor, ...arguments)"
                style="height: 100%; width: 100%;">
        </ace-editor>
        <textarea
          v-if="editorInfo.content === 'editor' && $q.platform.is.mobile"
          :ref="'ace' + editor"
          :value="aceContent(editor)"
          @input="textareaCodeChange(editor, ...arguments)"
          onscroll="textareaScrollHandler(editor, ...arguments)">
        </textarea>
        <q-scroll-area class="allow-touch col" style="height: 100%; width: 100%; overflow: hidden;" ref="contentScroller" v-if="editorInfo.content === 'preview'">
          <div class="q-ma-md render-container" v-html="renderedMd" @click="setcursor"></div>
        </q-scroll-area>
        <q-scroll-area class="allow-touch col" style="height: 100%; width: 100%; overflow: hidden; position: absolute;" ref="contentScroller" v-if="typeof editorInfo.content === 'object'">
            <component v-bind:is="editorInfo.content"></component>
        </q-scroll-area>
      </div>
    </div>
    <file-upload ref="uploader"/>
    <compare-modal ref="compareModal"/>
    <remember-this-modal ref="rememberThisModal"/>
    <published-note-modal ref="publishedNoteModal"/>
  </q-page>
</template>

<script>
import editor from '../components/AceVue'
import 'ace-builds/src-noconflict/mode-markdown'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-monokai'
import 'ace-builds/src-noconflict/ext-searchbox'
// import 'ace-builds/src/typo'
import 'ace-builds/src-noconflict/ext-spellcheck'

import Split from 'split.js'
import { updateCustomMd, resetCustomMd } from '../js/customMdParse/customMdParse'
import { ComponentDefinition } from '../js/customMdParse/ComponentDefinition'
import { updateComponentHtmlInDOM } from '../js/customMdParse/components'
import CompareObjectsModal from '../components/CompareObjectsModal'
import PublishedNoteModal from '../components/PublishedNoteModal'
import FileUpload from '../components/FileUpload'
import { findNoteHelper, createNewNote } from '../js/noteTemplates/noteHelpers'
import NoteHelper from '../js/noteTemplates/NoteHelper'
import RememberThisModal from '../components/RememberThisModal'

function isInFullScreen () {
  return (document.fullscreenElement && document.fullscreenElement !== null) ||
    (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
    (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
    (document.msFullscreenElement && document.msFullscreenElement !== null)
}

function requestFullScreen (element) {
  if (isInFullScreen()) return
  var docElm = document.documentElement
  if (docElm.requestFullscreen) {
    docElm.requestFullscreen()
  } else if (docElm.mozRequestFullScreen) {
    docElm.mozRequestFullScreen()
  } else if (docElm.webkitRequestFullScreen) {
    docElm.webkitRequestFullScreen()
  } else if (docElm.msRequestFullscreen) {
    docElm.msRequestFullscreen()
  }
}

function exitFullScreen () {
  if (!isInFullScreen()) return
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

export default {
  data () {
    return {
      splitterModel: 50,
      saveTimeout: null,
      layoutOrientation: 'horizontal',
      unsavedChanges: false,
      updatingNote: false,
      item: null,
      noteHelper: null,
      renderedMd: '',
      splits: {
        userdata: { visible: false, index: 0, icon: 'mdi-code-braces', locked: false, name: 'User Data', content: 'editor' },
        data: { visible: true, index: 1, icon: 'mdi-markdown', locked: false, name: 'Data', content: 'editor' },
        preview: { visible: true, index: 2, icon: 'far fa-newspaper', locked: false, name: 'Preview', content: 'preview' }
      },
      splitter: null,
      maxEditors: 3,
      editorConfig: {},
      itemChangeListenerCancel: null,
      refreshEditorListenerCancel: null,
      overrideView: false,
      overrideViewVue: null
    }
  },
  components: {
    RememberThisModal,
    editor,
    'compare-modal': CompareObjectsModal,
    FileUpload,
    'published-note-modal': PublishedNoteModal
  },
  computed: {
    defaultEditorSettings () {
      // @see https://github.com/ajaxorg/ace/wiki/Configuring-Ace
      let editorSettings = this.$store.state.auth.currentUser.settings.editor
      let defaultOpts = {
        navigateWithinSoftTabs: true,
        animatedScroll: true,
        showInvisibles: false,
        printMargin: false,
        fontSize: '10px',
        // fontFamily: '',
        scrollPastEnd: 0.25,
        // theme: '',
        overwrite: false,
        newLineMode: 'auto', // "auto" | "unix" | "windows"
        useSoftTabs: true,
        useWorker: true,
        tabSize: 2,
        wrap: 'free',
        wrapBehavioursEnabled: true,
        foldStyle: 'markbegin', // "markbegin"|"markbeginend"|"manual"
        keyboardHandler: 'vim'
      }
      if (this.$store.state.auth.currentUser == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings.editor == null) return defaultOpts
      let opts = Object.assign(defaultOpts, editorSettings)
      delete opts['lineNumbers']
      return opts
    },
    componentDefinitionAry () {
      let retAry = []
      let allRawCmpDefs = Object.values(this.$store.state.components.components) // eslint-disable-line no-unused-vars
      let enRawCmpDefs = this.$_.without(this.$_.map(this.$store.state.components.components, v => {
        return v.enabled ? v : null
      }), null)
      resetCustomMd()
      enRawCmpDefs.forEach(rawCompDef => {
        retAry.push(new ComponentDefinition(
          rawCompDef.id,
          rawCompDef.name,
          rawCompDef.code.md,
          rawCompDef.code.css,
          rawCompDef.code.html,
          rawCompDef.code.js,
          rawCompDef.code.scripts,
          rawCompDef
        ))
      })
      console.log('generate new component definition ary')
      return retAry
    },
    distractionFreeMode: {
      get () {
        return this.$store.state.ui.distractionFreeMode
      },
      set (v) {
        this.$store.commit('setDistractionFreeMode', v)
      }
    },
    userDataAsText () {
      return JSON.stringify(this.item.userData, null, 2)
    }
  },
  watch: {
    // 'item.userData': function (newUserData, oldUserData) {
    //   if (newUserData === undefined || oldUserData === undefined) return
    //   const oldTemplateId = (newUserData || {}).templateId
    //   const newTemplateId = (oldUserData || {}).templateId
    //   const vm = this
    //   if (oldTemplateId !== newTemplateId) {
    //     if (!newTemplateId) return
    //     this.$nextTick(() => {
    //       vm.pullNoteFromStore(vm.item.id)
    //     })
    //   }
    // }
  },
  methods: {
    publish () {
      this.$refs['publishedNoteModal'].show(this.noteHelper)
    },
    scrollHandler (editor, y) {
      if (editor !== 'data') return
      let aceEditor = this.$refs['ace' + editor][0].editor
      let aceHeight = aceEditor.session.getScreenLength() * aceEditor.renderer.lineHeight
      let contentScroller = this.$refs['contentScroller'][0]
      let contentScrollerHeight = contentScroller.scrollHeight
      contentScroller.setScrollPosition(y / aceHeight * contentScrollerHeight)
    },
    textareaScrollHandler (editor) {
      // TODO: implement me!
      // if (editor !== 'data') return
      // let textArea = this.$refs['ace' + editor][0]
      // let aceHeight = aceEditor.session.getScreenLength() * aceEditor.renderer.lineHeight
      // let contentScroller = this.$refs['contentScroller'][0]
      // let contentScrollerHeight = contentScroller.scrollHeight
      // contentScroller.setScrollPosition(y / aceHeight * contentScrollerHeight)
    },
    aceOpts (editorName) {
      let editorSettings = Object.assign({}, this.defaultEditorSettings)
      switch (editorName) {
        case 'data':
          editorSettings.spellcheck = true
          editorSettings.mode = 'markdown'
          break
        case 'userdata':
          editorSettings.spellcheck = true
          editorSettings.mode = 'json'
          break
      }

      return editorSettings
    },
    aceContent (editorName) {
      if (editorName === 'data') {
        return this.item.data
      } else if (editorName === 'userdata') {
        return this.userDataAsText
      }
    },
    getCustomButtonVm (btn) {
      let vm = btn.vm
      if (!vm) {
        // vm = this.noteHelper.noteTemplateInst
        vm = this
      } else if (vm === 'template') {
        vm = this.noteHelper.noteTemplateInst
      } else if (vm === 'editor') {
        vm = this
      }
      return vm
    },
    customButtonIcon (btn) {
      if (typeof btn.icon === 'function') {
        let vm = this.getCustomButtonVm(btn)
        return btn.icon.bind(vm).call()
      } else if (typeof btn.icon === 'string') {
        return btn.icon
      }
    },
    customButtonName (btn) {
      if (typeof btn.name === 'function') {
        let vm = this.getCustomButtonVm(btn)
        return btn.name.bind(vm).call()
      } else if (typeof btn.name === 'string') {
        return btn.name
      }
    },
    customButtonClick (btn) {
      let vm = this.getCustomButtonVm(btn)
      if (typeof btn.callback === 'function') {
        btn.callback.bind(vm).call()
      } else if (typeof btn.callback === 'string') {
        vm[btn.callback].bind(vm).call()
      }
    },
    sortByKeys (unordered) {
      const ordered = {}
      Object.keys(unordered).sort().forEach(key => {
        ordered[key] = unordered[key]
      })
      return ordered
    },
    showCompareModal (local, remote) {
      return this.$refs['compareModal'].show(
        JSON.stringify(this.sortByKeys(local), null, 2).replaceAll('\\\\n', '\n'),
        JSON.stringify(this.sortByKeys(remote), null, 2).replaceAll('\\\\n', '\n'))
      // return this.$refs['compareModal'].show(local.data, remote.data)
    },
    render () {
      if (this.$store.state.ui.skipMdRender) {
        console.log('skiprender')
        this.$store.commit('setSkipMdRender', false)
        return this.renderedMd
      }
      // console.log('rendered!!')
      let curPos = null
      // if (this.codemirror() && this.codemirror().hasFocus() && !this.$q.platform.is.mobile) {
      //   curPos = this.codemirror().indexFromPos(this.codemirror().getCursor())
      // }
      this.renderedMd = updateCustomMd(this.item.data || '', this.componentDefinitionAry, this.item, curPos, false, this.saveThrottled) // eslint-disable-line vue/no-side-effects-in-computed-properties
      this.renderedMd = this.renderedMd + '<div style="width: 100%; height: 25vh;"></div>' // eslint-disable-line vue/no-side-effects-in-computed-properties
      updateComponentHtmlInDOM()
    },
    saveNow () {
      // Clear any pending saves
      clearTimeout(this.saveTimeout)
      this.saveTimeout = null
      // Check item exists
      if (this.item == null) {
        console.log('Could not save item ' + this.$route.params.id)
        return Promise.all([])
      }
      // Check that there are changes to save
      if (!this.unsavedChanges) {
        return Promise.all([])
      }
      return this.noteHelper.save().catch((e) => {
        this.$q.notify({
          message: 'Error Saving note ' + e,
          type: 'negative',
          position: 'bottom',
          actions: [
            {
              label: 'debug (ctrl-shift-J)',
              icon: 'mdi-bug',
              handler: () => {
                // modalFn(DebugModal, {ex: ex}) // .show(ex)
                this.$q.dialog({
                  title: 'Error',
                  message: 'Press ctrl-shift-J to show the error in your browser\'s debugging tools.', // ex.stack,
                  ok: true,
                  cancel: false
                })
              }
            }
          ]
        })
        console.warn(e)
      })
    },
    /**
     * Save with a timeout
     * @param saveDelayMs ms to delay before saving
     */
    saveThrottled (saveDelayMs) {
      this.unsavedChanges = true
      clearTimeout(this.saveTimeout) // Reset timer (ie. delay save to 1s from now instead of whatever the timeout value was)
      this.saveTimeout = setTimeout(() => {
        this.render()
        this.saveNow().then()
      }, saveDelayMs || 1000)
    },
    /**
     * When one of the ace editors change their content because the user types in it.
     */
    codeChange (editorName, newCode) {
      if (this.updatingNote) return
      // console.log(newCode)
      if (editorName === 'userdata') {
        if (!newCode) return
        const newUserData = JSON.parse(newCode)
        if (this.$_.isEqual(this.item.userData, newUserData)) return
        // if (JSON.stringify(this.item.userData, null, 2) === newCode || newCode === '') return
        // if (this.$refs['aceuserdata'][0].getValue() === newCode || newCode === '') return
        console.log('change code user data: ' + newCode)
        this.item.userData = newUserData
      } else {
        if (this.item[editorName] === newCode) return
        this.item[editorName] = newCode
      }
      this.saveThrottled()
    },
    textareaCodeChange (editorName, other) {
      if (this.updatingNote) return
      if (!this.$refs['ace' + editorName]) return

      let newCode = this.$refs['ace' + editorName][0].value

      if (editorName === 'userdata') {
        if (!newCode) return
        if (JSON.stringify(this.item.userData, null, 2) === newCode) return
        this.item.userData = JSON.parse(newCode)
      } else {
        if (this.item[editorName] === newCode) return
        this.item[editorName] = newCode
      }
      this.saveThrottled()
    },
    switchOrientation () {
      if (this.layoutOrientation === 'horizontal') {
        this.layoutOrientation = 'vertical'
      } else {
        this.layoutOrientation = 'horizontal'
      }
      this.recreateSplits()
    },
    showEditorSettings () {
      this.$store.dispatch('openSettingsDialog', 'editor')
    },
    toggleDistractionFreeMode (fullscreen) {
      this.distractionFreeMode = !this.distractionFreeMode
      if (fullscreen) {
        requestFullScreen()
      } else {
        exitFullScreen()
      }
    },
    openInPopup () {
      window.open(window.location.href, '_blank', 'menubar=no,statusbar=no')
    },
    configureEditor (config) {
      // Standard layout
      this.overrideView = false
      this.editorConfig = config
      this.splits = config.splits

      this.$nextTick(() => {
        this.recreateSplits(false)
        this.render()
      })
    },
    // Only gets called if there was a change on the server!
    onNoteChange (newData) {
      this.updatingNote = true
      this.item = newData
      const dataEditor = (this.$refs['acedata'][0] || {}).editor
      const userDataEditor = (this.$refs['aceuserdata'][0] || {}).editor

      if (dataEditor) {
        const pos = dataEditor.session.selection.toJSON()
        dataEditor.setValue(this.item.data)
        dataEditor.session.selection.fromJSON(pos)
      }
      if (userDataEditor) {
        const pos = userDataEditor.session.selection.toJSON()
        userDataEditor.setValue(this.userDataAsText)
        userDataEditor.session.selection.fromJSON(pos)
      }
      this.render()
      this.updatingNote = false
      // this.showCompareModal(this.item, this.noteHelper.item).then(() => {
      //   // this.pullNoteFromStore(this.item.id)
      //   this.item = this.$_.cloneDeep(this.noteHelper.note)
      // }).catch((err) => {
      //   console.log('Local version kept, remote version ignored: ' + err)
      // })
    },
    pullNoteFromStore (id) {
      let t = this
      t.updatingNote = true
      if (this.itemChangeListenerCancel) this.itemChangeListenerCancel()
      if (this.refreshEditorListenerCancel) this.refreshEditorListenerCancel()
      this.noteHelper = findNoteHelper(id)
      return this.noteHelper.onAccess().then(() => {
        return t.noteHelper.configureEditor()
      }).then(config => {
        t.item = t.noteHelper.note
        t.itemChangeListenerCancel = t.noteHelper.addEventListener('change', t.onNoteChange)
        t.refreshEditorListenerCancel = t.noteHelper.addEventListener('refreshEditor', t.configureEditor)
        if (t.item == null) t.$router.replace('/home')
        t.unsavedChanges = false
        resetCustomMd()
        window.$ch._resetStorageURLs()
        t.configureEditor(config)
        t.updatingNote = false
      }).catch((ex) => {
        t.$router.replace('/home')
        console.warn(ex)
        console.warn('Error pulling item ' + id + 'from store.')
        t.updatingNote = false
      })
    },
    checkZeroWidthSplits () {
      let needsUpdate = false
      let sizes = this.splitter.getSizes()
      let openSplits = this.$_.sortBy(this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? v : null }), null), 'index')
      sizes.forEach((s, i) => {
        if (s < 1) {
          openSplits[i].visible = false
          needsUpdate = true
        }
      })
      if (needsUpdate) this.recreateSplits()
    },
    refreshVisibleEditors () {
      this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? 'ace' + k : null }), null).forEach(en => {
        if (en === 'acepreview') return
        this.updateEditorWrapping(en)
      })
    },
    updateEditorWrapping (editorName) {
      if (!(editorName in this.$refs)) return
      if (!('updateEditorWrapping' in this.$refs[editorName][0])) return
      this.$refs[editorName][0].updateEditorWrapping()
    },
    recreateSplits (preserveWidths) {
      if (this.overrideView) return
      let selectors = this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? '#ace' + k + 'div' : null }), null)
      let widths = null

      if (preserveWidths && this.splitter) {
        widths = this.splitter.getSizes()
      }

      if (this.splitter) {
        this.splitter.destroy()
      }

      let t = this
      this.splitter = Split(selectors, {
        sizes: widths,
        minSize: 0,
        gutterSize: 8,
        direction: this.layoutOrientation,
        onDragEnd: function () {
          // localStorage.setItem('split-sizes', JSON.stringify(split.getSizes()));
          t.checkZeroWidthSplits()
          // t.refreshVisibleEditors()
        },
        elementStyle: function (dimension, size, gutterSize) {
          return {
            'flex-basis': 'calc(' + size + '% - ' + gutterSize + 'px)'
          }
        },
        gutterStyle: function (dimension, gutterSize) {
          return {
            'flex-basis': gutterSize + 'px'
          }
        }
      })
      this.$nextTick(() => {
        t.refreshVisibleEditors()
      })
    },
    visibleSplits () {
      return this.$_.countBy(this.splits, 'visible')[true]
    },
    visibleUnlockedSplits () {
      return this.$_.pickBy(this.splits, s => s.visible && !s.locked)
    },
    closeExtraSplits (aboutToOpen) {
      while (this.visibleSplits() + (aboutToOpen ? 1 : 0) > this.maxEditors) { // eslint-disable-line no-unmodified-loop-condition
        this.splits[Object.keys(this.visibleUnlockedSplits())[0]].visible = false
        // this.splits[this.$_.findKey(this.splits, ['visible', true])].visible = false
      }
    },
    clickSetSplit (split) {
      if (!split.visible) {
        if (Object.keys(this.visibleUnlockedSplits()).length + 1 <= this.maxEditors) {
          this.setSplitVisible(split, 'true')
        }
      // } else if (split.visible && !split.locked) {
      //   split.locked = true
      } else {
        split.locked = false
        this.setSplitVisible(split, false)
      }
    },
    setSplitVisible (split, visible) {
      if (visible === 'toggle') visible = !split.visible
      let preserveWidths = false
      let openSplits = this.visibleSplits()
      // Not allowed to turn all splits off.  Must keep at least one!
      if (openSplits === 1 && !visible) return
      this.closeExtraSplits(visible)
      split.visible = visible
      if (this.visibleSplits() === openSplits) preserveWidths = true // Same number of splits?
      this.recreateSplits(preserveWidths)
    },
    insertImage () {
      let t = this
      this.$refs.uploader.show(this.item.id).then((fileName) => {
        let editor = t.$refs.acedata[0].editor
        let text = '!img(' + fileName + ')'
        editor.session.insert(editor.getCursorPosition(), text)
      })
    },
    extractToSubnote () {
      let _vm = this
      let editor = _vm.$refs.acedata[0].editor
      let title = editor.getSelectedText()
      let newItem = { data: '# ' + title + '\nWrite your thoughts here...', userData: {}, children: [] }
      createNewNote(newItem, this.item.id).then((newNoteHelper) => {
        // this.expandedTreeItemIds.push(this.item.id)
        // this.selectedTreeItemId = newNoteHelper.noteId
        editor.session.replace(editor.selection.getRange(),
          '!![' + title.replace('[', '').replace(']', '') + ']' + newNoteHelper.noteId)
        _vm.$router.push(`/home/${newNoteHelper.noteId}`)
      })
      // this.$refs.uploader.show(this.item.id).then((fileName) => {
      //   let editor = _vm.$refs.acedata[0].editor
      //   let text = '!img(' + fileName + ')'
      //   editor.session.insert(editor.getCursorPosition(), text)
      // })
    },
    newScratchNote () {
      let scratchRoot = NoteHelper.sessionRootNote.children().find(c => c.name === 'Scratch Notes')
      let promise = new Promise((resolve, reject) => resolve(scratchRoot))
      if (!scratchRoot) {
        let scratchRootItem = { data: '# Scratch Notes\nPut any temp notes under here.\nYou may want to go through and re-organise them later', userData: {}, children: [] }
        promise = createNewNote(scratchRootItem, NoteHelper.sessionRootNote.noteId)
      }
      promise.then(scratchRootHelper => {
        // Todo: Nicer Date!
        let scratchItem = { data: `# Scratch Note ${Date.now().toString()}\n...`, userData: {}, children: [] }
        createNewNote(scratchItem, scratchRootHelper.noteId).then(newScratchNote => {
          this.$router.push(`/home/${newScratchNote.noteId}`)
        })
      })
    },
    rememberSomething (textToRemember) {
      let _vm = this
      // Create 'Remember' root under this session
      let rememberRoot = NoteHelper.sessionRootNote.children().find(c => c.name === 'Remember')
      let promise = new Promise((resolve, reject) => resolve(rememberRoot))
      if (!rememberRoot) {
        let templateId = (this.$store.getters.getNoteTemplatesAsAry.find(t => t.name === 'Remember') || {}).id
        if (!templateId) {
          this.$q.notify(`'Remember' note template does not exist.`)
          throw new Error('no such template "Remember Item"')
        }
        let rememberRootItem = { data: '# Remember\nThings to know/remember', userData: { templateId }, children: [] }
        promise = createNewNote(rememberRootItem, NoteHelper.sessionRootNote.noteId)
      }
      // Create the new note under the 'remember root'
      promise.then(scratchRootHelper => {
        let templateId = (this.$store.getters.getNoteTemplatesAsAry.find(t => t.name === 'Remember Item') || {}).id
        if (!templateId) {
          this.$q.notify(`'Remember Item' note template does not exist.`)
          throw new Error('no such template "Remember Item"')
        }
        let newItem = {
          data: `# ${this.noteHelper.name}
${textToRemember}`,
          userData: {
            sourceNoteId: _vm.noteHelper.noteId,
            templateId,
            revisions: []
          },
          children: []
        }
        createNewNote(newItem, scratchRootHelper.noteId).then(newScratchNote => {
          _vm.$q.notify({
            message: 'Saved!',
            type: 'positive'
          })
        })
      })
    },
    rememberThis () {
      let editor = this.$refs.acedata[0].editor
      let textToRemember = editor.getSelectedText()
      if (!textToRemember) {
        this.$q.dialog({
          title: 'What do you want to remember?',
          prompt: {
            model: '',
            type: 'text' // optional
          },
          cancel: true
        }).onOk(data => {
          this.rememberSomething(data)
        })
      } else {
        this.$refs.rememberThisModal.show(textToRemember).then((rememberTextWithClosures) => {
          this.rememberSomething(rememberTextWithClosures)
        })
      }
    },
    setcursor (e) {
      // TODO: map from html element into position in the markdown!!
      // const target = this.getTarget(e)
      // console.log(target)
    },
    getTarget (e) {
      if (e.target) return e.target
      else if (e.srcElement) return e.srcElement
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.pullNoteFromStore(vm.$route.params.id)
    })
  },
  beforeRouteLeave (to, from, next) {
    this.saveNow()
    if (this.itemChangeListenerCancel) this.itemChangeListenerCancel()
    if (this.refreshEditorListenerCancel) this.refreshEditorListenerCancel()
    next()
  },
  beforeRouteUpdate (to, from, next) {
    this.saveNow()
    this.pullNoteFromStore(to.params.id).then(() => {
      const dataRef = this.$refs['acedata'][0]
      const userDataRef = this.$refs['aceuserdata'][0]
      if (dataRef) {
        if (dataRef instanceof HTMLTextAreaElement) {
          dataRef.innerText = this.item.data
        } else {
          dataRef.setValue(this.item.data)
        }
      }
      if (userDataRef) {
        if (userDataRef instanceof HTMLTextAreaElement) {
          userDataRef.innerText = this.userDataAsText
        } else {
          userDataRef.setValue(this.userDataAsText)
        }
      }
      next()
    })
  }
}
</script>

<style lang="styl">
  .allow-touch .q-touch {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  ::-webkit-scrollbar {
    width: 0.5em;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(100, 100, 100, 0.8);
  }

  ::-webkit-scrollbar-corner,
  ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(100, 100, 100, 0.4);
  }

  /*textarea, #editor div {*/
    /*!*display: inline-block;*!*/
    /*!*width: 100%;*!*/
    /*!*height: 100%;*!*/
    /*vertical-align: top;*/
    /*!*box-sizing: border-box;*!*/
    /*padding: 0 20px;*/
  /*}*/

  .col > textarea {
    height: 100%;
    width: 100%;
    border: none;
    border-right: 1px solid #ccc;
    resize: none;
    outline: none;
    background-color: #f6f6f6;
    font-size: 14px;
    font-family: 'Monaco', courier, monospace;
    padding: 20px;
  }

  code {
    color: #f66;
  }
</style>
